import { render, staticRenderFns } from "./add-town-popup.vue?vue&type=template&id=9aa3a668"
import script from "./add-town-popup.vue?vue&type=script&lang=js"
export * from "./add-town-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports